import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { MaskedLines, FadeIn } from "./motion";

export default function PageHeader({ eyebrow, lines, crumb }) {
  return (
    <div className="relative grain bg-tint border-b border-line overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 pt-40 pb-16 sm:pb-20">
        <FadeIn>
          <nav aria-label="Breadcrumb" data-testid="breadcrumb-nav">
            <ol className="flex items-center gap-1.5 text-xs sm:text-sm text-ink-soft font-semibold uppercase tracking-widest">
              <li>
                <Link to="/" data-testid="breadcrumb-home-link" className="hover:text-terracotta transition-colors duration-300">
                  Beranda
                </Link>
              </li>
              <li className="flex items-center gap-1.5">
                <ChevronRight size={14} aria-hidden="true" />
                <span className="text-terracotta" aria-current="page">{crumb}</span>
              </li>
            </ol>
          </nav>
        </FadeIn>
        {eyebrow && (
          <FadeIn delay={0.1}>
            <p className="mt-6 text-sm font-bold uppercase tracking-[0.25em] text-amberbrand">{eyebrow}</p>
          </FadeIn>
        )}
        <MaskedLines
          lines={lines}
          className="mt-3 font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl text-ink"
        />
      </div>
    </div>
  );
}
